"use client";

import { RefObject, useLayoutEffect, useState } from "react";
import { NAV_SLOT } from "@/utils/constants";

type NavSlot = (typeof NAV_SLOT)[keyof typeof NAV_SLOT];

export function useNavSlotPortal(
  containerRef: RefObject<HTMLElement | null>,
  slot: NavSlot,
  deps: readonly unknown[]
): HTMLElement | null {
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    const target = containerRef.current?.querySelector<HTMLElement>(
      `[data-wse-nav-slot="${slot}"]`
    );
    setPortalTarget((currentTarget) =>
      currentTarget === (target ?? null) ? currentTarget : target ?? null
    );
    // The injected fragment key controls when its DOM is replaced.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef, slot, ...deps]);

  return portalTarget;
}
